import axios from "axios";

export const getPosts = async () => {
    try {
        const res = await axios.get(
            `https://graph.facebook.com/v21.0/me/feed?fields=id,message,full_picture,created_time,attachments&access_token=${process.env.REACT_APP_FACEBOOK_TOKEN}`,
            {withCredentials: false}
        );

        return res.data.data;
    } catch (e) {
        console.error(e);
        return [];
    }
};

export const getUpcomingEvent = async () => {
    const posts = await getPosts();

    const upcomingPost = posts.find(({message}) => message.includes('#upcomingEvent'));

    if (!upcomingPost) return null;
    
    return {
        ...parseEvent(upcomingPost.message),
        image: upcomingPost.full_picture,
    }
}

function parseEvent(input) {
    const lines = input.split("\n").map(line => line.trim());

    const titleIndex = lines.findIndex(line => line.startsWith("📍"));
    const title = titleIndex !== -1 ? lines[titleIndex].replace("📍", "").trim() : "";

    const dateIndex = lines.findIndex(line => line.startsWith("⏱"));
    const date = dateIndex !== -1 ? lines[dateIndex].replace("⏱", "").trim() : "";

    const tagIndex = lines.findIndex(line => line.startsWith('#upcomingEvent'));
    const descriptionLines = lines.slice(Math.max(titleIndex, dateIndex) + 1, tagIndex).filter(Boolean);

    return { title, date, descriptionLines };
}
